export enum OrderDir {
  ASC = 'ASC',
  DESC = 'DESC',
}
